{
	"label": "Categorías",
	"addAll": "Agregar todos",
	"removeAll": "Eliminar todos"
}
